import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import * as Icons from "assets/icons";

import * as Grid from "components/Grid";

import Collapse from "./components/Collapse";

import cls from "./StageSteps.module.scss";

const StageSteps = ({ stageSteps }) => {
  const { t } = useTranslation();
  const [stepId, setStepId] = useState(null);

  return (
    <div className={cls.wrapper}>
      <div className={cls.head}>
        <div className={cls.headLeft}>
          <Icons.FolderCode />
        </div>

        <div className={cls.headCenter}>
          <div className={cls.headCenterTitle}>{t("stage_steps")}</div>
          {/* <div className={cls.headCenterStatuses}>
            {stageSteps && (
              <div className={cls.headCenterStatus}>{t('stageSteps')}</div>
            )}
            {activityType && (
              <div className={cls.headCenterStatus}>{t(activityType)}</div>
            )}
          </div> */}
        </div>

        {/* <div className={cls.headRight}>
          <div className={cls.headRightTitle}>
            {t("users_of_the_function_result")}
          </div>
        </div> */}
      </div>

      {stageSteps.length ? (
        <div className={cls.body}>
          <Grid.Row gutter={[24, 24]}>
            {stageSteps.length ? (
              <Grid.Col xs={24}>
                {/* <div className={cls.bodyTitle}>
                  {t("information_system_created_within_the_function")}
                </div> */}

                <div className={cls.bodyList}>
                  {stageSteps.map((item) => (
                    <Collapse
                      order={item.order_number}
                      name={item.name}
                      steps={item.steps}
                      open={item.id === stepId}
                      onClick={() => {
                        if (!stepId || stepId !== item.id) {
                          setStepId(item.id);
                        } else {
                          setStepId(null);
                        }
                      }}
                      key={item.id}
                    />
                  ))}
                </div>
              </Grid.Col>
            ) : null}
          </Grid.Row>
        </div>
      ) : null}
    </div>
  );
};

export default StageSteps;
